export default [
  'BOTArticleCategories'
]

/*
Appears on:
/resources
*/
